import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Branded } from "@@/utilities/branded";
import { generateId } from "@@/utilities/generate-id";

type ShortLinkId = Branded<string, "ShortLinkId">;

type ShortLink = {
    _id: ShortLinkId;
    _type: "SHORT_LINK";
    _created: IsoAndUnixTimestamp;
    url: string;
    targetUrl: string;
    targetId: string;
};

const createShortLinkId = (): ShortLinkId =>
    generateId({ prefix: "short_link__" });
const createShortLink = (params: {
    url: string;
    targetUrl: string;
    targetId: string;
}): ShortLink => ({
    ...params,
    _id: createShortLinkId(),
    _created: nowIsoAndUnix(),
    _type: "SHORT_LINK",
});

export { createShortLink, createShortLinkId };
export type { ShortLink, ShortLinkId };
